import React from 'react';
import { Instagram, Facebook, Phone, MapPin } from 'lucide-react';
import { businessInfo } from '../data/mock';
import { trackNav, trackSocial } from '../lib/analytics';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    trackNav(`footer_${id}`);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const SECTION_LABELS = {
    servicos: 'Serviços',
    equipe: 'Equipe',
    sobre: 'Sobre',
    instagram: 'Instagram',
    localizacao: 'Localização',
  };

  const getSectionLabel = (id) => SECTION_LABELS[id] || id;

  return (
    <footer className="bg-black/85 backdrop-blur-md border-t border-zinc-900">
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <h3 className="text-white font-bold text-2xl mb-4">
              ABR <span className="text-[#D4AF37]">Barbearia</span>
            </h3>
            <p className="text-gray-400 mb-6">
              Barbearia premium em Jundiaí com atendimento de alto padrão.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://instagram.com/abrbarbearia" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={() => trackSocial('instagram')}
                className="w-10 h-10 bg-zinc-900 rounded-sm flex items-center justify-center hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="https://facebook.com/abrbarbearia" 
                target="_blank" 
                rel="noopener noreferrer"
                onClick={() => trackSocial('facebook')}
                className="w-10 h-10 bg-zinc-900 rounded-sm flex items-center justify-center hover:bg-[#D4AF37] hover:text-black transition-all duration-300"
              >
                <Facebook className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Links Rápidos</h4>
            <ul className="space-y-2">
              {['servicos', 'equipe', 'sobre', 'instagram', 'localizacao'].map((id) => (
                <li key={id}>
                  <button
                    onClick={() => scrollToSection(id)}
                    className="text-gray-400 hover:text-[#D4AF37] transition-colors capitalize"
                  >
                    {getSectionLabel(id)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Contato</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-400">
                <Phone className="h-5 w-5 text-[#D4AF37] flex-shrink-0 mt-1" />
                <span>(11) 93907-9671</span>
              </li>
              <li className="flex items-start gap-3 text-gray-400">
                <MapPin className="h-5 w-5 text-[#D4AF37] flex-shrink-0 mt-1" />
                <span>{businessInfo.address.full}</span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-white font-semibold text-lg mb-4">Horário</h4>
            <div className="space-y-2 text-gray-400">
              <p className="font-medium text-white">{businessInfo.hours.weekdays}</p>
              <p>{businessInfo.hours.time}</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-zinc-900">
        <div className="container mx-auto px-4 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-500 text-sm">
              &copy; {currentYear} ABR Barbearia. Todos os direitos reservados.
            </p>
            <p className="text-gray-500 text-sm">
              Desenvolvido com <span className="text-[#D4AF37]">♥</span> para oferecer a melhor experiência
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;